export const colors = {
  white: "#FFFFFF",
  darkBlue: "#122243",
  lightBlueGray: "#7E8AAD33",
  lightBlueGrayBackground: "#7E8AAD0F",
  blueGray: "#7E8AAD",
  green: "#34C759",
  red: "#FF2D55",
  teal: "#00C7BE",
  yellow: "#FFCC00",
  lightBlueGrayAlpha: "#7E8AAD1A",
  lightBlueGrayAlpha40: "#7E8AAD40",
  lightGray: "#F7F8FA",
  gray: "#f1f1f1",
  blue: "#007AFF",
  blueAlpha: "#007AFF1A",
  orange: "#FF9500",
  purple: "#AF52DE",
  darkBlueAlpha59: "#1222433B",
  lightGrayBlue: "#E5E5E7",
  blueGrayAlpha80: "#7E8AAD80",
  darkBlueAlpha80: "#12224380",
  gradientTeal: "#00EAB2",
  gradientBlue: "#004EF7",
};
